import React from "react";
import { useFormState } from "react-final-form";
import { motion, AnimateSharedLayout } from "framer-motion";
import RadioBlock from "../../components/RadioBlock";
import { Error } from "../../components/Validation";
import { containerVariants, itemVariants } from "../../animate/helpers";

const House = "assets/images/house.png";
const Condo = "assets/images/condo.png";
const Apartment = "assets/images/apartment.png";
const Castle = "assets/images/castle.png";

const DwellingType = () => {
  const formState = useFormState();
  const selected = formState.values.live_in;
  return (
    <>
      <motion.div variants={itemVariants}>
        <label className="form-group__header top-margin" htmlFor="live_in">
          I live in ...
        </label>
      </motion.div>
      <AnimateSharedLayout>
        <motion.div
          className="radio-row"
          variants={containerVariants}
          initial="hidden"
          animate="show"
        >
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="a house"
              image={House}
              name="live_in"
              value="house"
              isSelected={selected === "house"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="a condo"
              image={Condo}
              name="live_in"
              value="condo"
              isSelected={selected === "condo"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="an apartment"
              image={Apartment}
              name="live_in"
              value="apartment"
              isSelected={selected === "apartment"}
            />
          </motion.div>
          <motion.div variants={itemVariants}>
            <RadioBlock
              title="none of these"
              image={Castle}
              name="live_in"
              value="other"
              isSelected={selected === "other"}
            />
          </motion.div>
        </motion.div>
      </AnimateSharedLayout>

      <Error name="live_in" />
    </>
  );
};

export default DwellingType;
